import React from "react";
import { Link, NavLink } from "react-router-dom";
import { RiMovie2Line } from "react-icons/ri";

import { BsBookmarkPlus } from "react-icons/bs";
import useAuthContext from "../../components/AuthContext/AuthContext";
import SearchBox from "../../components/SearchBox/SearchBox";

const NavBar = () => {
  const { show, setShow, cart } = useAuthContext();

  const handleCartShow = (e) => {
    e.preventDefault();
    setShow(!show);
  };

  const hover = "hover:text-subMain transitions text-white";
  const Hover = ({ isActive }) => (isActive ? "text-subMain" : hover);

  return (
    // creating the navbar section of the movie app
    <div className="bg-main shadow-md sticky top-0 z-20">
      <div className="container mx-auto py-6 px-2 lg:grid gap-10 grid-cols-7 justify-between">
        <div className=" col-span-1 lg:block">
          <Link className="flex font-bold text-subMain text-6xl" to="/home">
            O{" "}
            <span className="flex text-3xl text-white py-4">
              scar'sTv
              <RiMovie2Line color="red" />
            </span>
          </Link>
        </div>
        {/* search box */}
        <div className="col-span-3 w-full">
          <SearchBox />
        </div>

        {/* navbar menu options */}

        <div className="col-span-3 font-medium text-sm hidden xl:gap-14 2xl:gap-20 justify-between lg:flex xl:justify-end items-center">
          <NavLink to="/movies" className={Hover}>
            <span className="font-semibold">Movies</span>
          </NavLink>

          <NavLink to="/contact-us" className={Hover}>
            <span className="font-semibold">Contact</span>
          </NavLink>

          <NavLink to="/about-us" className={Hover}>
            <span className="font-semibold">About Us</span>
          </NavLink>

          <button
            onClick={handleCartShow}
            className=" flex text-slate-100 relative"
          >
            <BsBookmarkPlus className=" w-6 h-6 font-bold " />
            <span className="absolute -top-1 -right-1 w-3 h-3 rounded-full bg-slate-100 flex justify-center items-center text-[0.65rem] text-slate-900">
              {cart.length}
            </span>
            <span className="py-2 font-semibold">WatchList</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default NavBar;
